import React, { useRef, useEffect } from "react";

const RippleEffect = () => {
    const rippleEffectrRef = useRef();
    useEffect(() => {
        // handle effect when clicked button is a link
        const handleClickLink = (event) => {
            const button = event.currentTarget;
            const href = button.getAttribute('href');
            const target = button.getAttribute('target') ?? "_self";
            const windowFeatures = button.getAttribute('data-features') ?? "";
            if (href) {
                event.preventDefault();
                setTimeout(() => {
                    window.open(href, target, windowFeatures);
                }, 100);
            }
        };

        const addRippleEffect = (event) => {
            const button = event.currentTarget;
            const ripple = document.createElement('div');
            ripple.className = 'ripple-effect';

            button.appendChild(ripple);

            // check if the button is a link
            if (button.tagName.toLowerCase() === "a") {
                handleClickLink(event);
            }

            setTimeout(() => {
                ripple.remove();
            }, 2000);
        };

        const button = rippleEffectrRef.current?.parentNode ?? null;
        if (button) {
            button.addEventListener('click', addRippleEffect);
        }
    }, [rippleEffectrRef]);

    return <div ref={rippleEffectrRef}></div>;
};
export default RippleEffect;
